import { isObject, get, result } from 'lodash';
import { SubmissionError } from 'redux-form';
import { setMessage } from '../../../../common/components/Notification/actions';
import dictionariesTypesEnum from '../../../../common/constants/dictionaries';
import APIClient from '../../../../common/services/APIClient';
import { DOMESTIC_CUSTOMER_INFO, loginError, logoutAndRedirect } from '../../../Login/actions';
import { initDictionaryList } from '../Dictionary/actions';
import { setCookie } from '../../../../common/cookies';

export const appendToFromDataIfExist = (formData, path, obj) => {
  formData.append(path, isObject(obj) ? obj.file : '');
};

const fillFromData = ({ publicSettings, logoMainUrl, logoNavbarUrl, logoIconUrl, privateSettings }) => {
  const formData = new FormData();

  appendToFromDataIfExist(formData, 'publicSettings', publicSettings);
  appendToFromDataIfExist(formData, 'logoMain', logoMainUrl);
  appendToFromDataIfExist(formData, 'logoNavbar', logoNavbarUrl);
  appendToFromDataIfExist(formData, 'logoIcon', logoIconUrl);
  appendToFromDataIfExist(formData, 'privateSettings', privateSettings);

  return formData;
};

const handleCreateEditDictionaryError = (error) => {
  const message = get(error, 'response.data.message');

  throw new SubmissionError({ _error: message });
};

export const loadDictionary = (name, paginationObj) => (dispatch) => {
  const loadAndSetDictionary = (name, paginationOpts) =>
    APIClient.get('/customers', paginationOpts).then((resp) => {
      const payloads = result(resp, 'data.payloads', []);
      const size = result(resp, 'data.total_size', 0);

      dispatch(initDictionaryList(name, { dictionary: payloads, total_size: size }));
    });
  const paginationOpts = {}; // TODO: remove later (for release only)

  if (paginationObj) {
    paginationOpts.page_token = 0;
    paginationOpts.page_size = 999;
    paginationOpts.hideCurrent = true;
  }
  const pagination = paginationObj ? { params: paginationOpts } : null;

  loadAndSetDictionary(name, pagination);
};

export const createDictionaryValue =
  (
    name,
    { url, note, status, publicSettings, privateSettings, logoMainUrl, logoNavbarUrl, logoIconUrl, customerId, customerName },
    paginationObj,
  ) =>
  (dispatch) =>
    APIClient.post(
      '/customers',
      fillFromData({
        publicSettings,
        logoMainUrl,
        logoNavbarUrl,
        logoIconUrl,
        privateSettings,
      }),
      {
        params: {
          customerId,
          customerName,
          url,
          note,
          status,
        },
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    )
      .then(() => {
        dispatch(loadDictionary(dictionariesTypesEnum.customers, paginationObj));
      })
      .catch(handleCreateEditDictionaryError);

export const editDictionaryValue =
  (
    name,
    { url, note, status, publicSettings, privateSettings, logoMainUrl, logoNavbarUrl, logoIconUrl, uuid, customerId, customerName },
    paginationObj,
  ) =>
  (dispatch) =>
    APIClient.put(
      `/customers/${uuid}`,
      fillFromData({
        publicSettings,
        logoMainUrl,
        logoNavbarUrl,
        logoIconUrl,
        privateSettings,
      }),
      {
        params: {
          url,
          note,
          status,
          uuid,
          customerName,
        },
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    )
      .then(() => {
        dispatch(loadDictionary(dictionariesTypesEnum.customers, paginationObj));
      })
      .catch(handleCreateEditDictionaryError);

export const loginToCustomer = (url, customerId, refreshToken) => (dispatch, getState) => {
  APIClient.get('/users/login/customer', { params: { url, customerId } })
    .then((resp) => {
      const {
        login: {
          user: { customer_id, customer_url, domain },
        },
      } = getState();

      dispatch(logoutAndRedirect(url, resp, refreshToken));
      dispatch(
        setCookie(
          DOMESTIC_CUSTOMER_INFO,
          JSON.stringify({
            customer_id,
            customer_url,
          }),
          domain,
        ),
      );
    })
    .catch((response) => {
      const message = get(response, 'data.message', null);

      if (message) {
        dispatch(
          setMessage({
            message,
            duration: 3000,
          }),
        );
      } else {
        dispatch(setMessage({ message: 'Customer authorization failed', duration: 3000 }));
      }
      dispatch(loginError('Customer authorization failed'));
    });
};

export const getCustomerSettings = (customerId) => APIClient.get(`/customers/${customerId}/settings`).then(({ data }) => data);

export const getSettingsSchema = () => APIClient.get('/customers/settings/schema').then(({ data }) => data);

export const saveCustomerSettings = (customerId, data) =>
  APIClient.put(`/customers/${customerId}/settings`, data, { headers: { 'Content-Type': 'text/plain' } });
